export const filterTypes = {
    inputChange: "[Custom Filters] Change Value",
    cleanFilter: "[Custom Filters] Clean Filter",
};
